// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.newGroceryCart {
  padding-top: 56px;
  width: 100%;
}

.newGroceryCartContainer {
  display: flex;
  height: calc(100vh - 178px);
}

.newGroceryCartLeft {
  width: 100%;
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background-color: var(--surface-white);
}

.newGroceryCartRight {
  height: 100%;
  box-sizing: border-box;
  width: 84px;
  flex-shrink: 0;
  background-color: var(--surface-white);
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}

.newGroceryCartRight::-webkit-scrollbar {
  width: 3px;
}

.newGroceryCartRight::-webkit-scrollbar-track {
  background: transparent;
}

.newGroceryCartRight::-webkit-scrollbar-thumb {
  background-color: #cbd5e1;
  border-radius: 9999px;
}

.groceryFloatingBottomWrapper {
  /* margin-top: -15px; */
  position: absolute;
  bottom: 62px;
  width: 100%;
  z-index: 10;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/components/twoWaykeyboardPaymentPage/indexV2.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,WAAW;EACX,cAAc;EACd,sCAAsC;EACtC,gBAAgB;EAChB,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,WAAW;AACb","sourcesContent":[".newGroceryCart {\n  padding-top: 56px;\n  width: 100%;\n}\n\n.newGroceryCartContainer {\n  display: flex;\n  height: calc(100vh - 178px);\n}\n\n.newGroceryCartLeft {\n  width: 100%;\n  height: 100%;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  background-color: var(--surface-white);\n}\n\n.newGroceryCartRight {\n  height: 100%;\n  box-sizing: border-box;\n  width: 84px;\n  flex-shrink: 0;\n  background-color: var(--surface-white);\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: #cbd5e1 transparent;\n}\n\n.newGroceryCartRight::-webkit-scrollbar {\n  width: 3px;\n}\n\n.newGroceryCartRight::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.newGroceryCartRight::-webkit-scrollbar-thumb {\n  background-color: #cbd5e1;\n  border-radius: 9999px;\n}\n\n.groceryFloatingBottomWrapper {\n  /* margin-top: -15px; */\n  position: absolute;\n  bottom: 62px;\n  width: 100%;\n  z-index: 10;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
